/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PromotionResponseDTOFromJSON, PromotionResponseDTOToJSON, } from './PromotionResponseDTO';
/**
 * Check if a given object implements the PromotionListResponseDTO interface.
 */
export function instanceOfPromotionListResponseDTO(value) {
    return true;
}
export function PromotionListResponseDTOFromJSON(json) {
    return PromotionListResponseDTOFromJSONTyped(json, false);
}
export function PromotionListResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(PromotionResponseDTOFromJSON)),
        'appliedShare': json['appliedShare'] == null ? undefined : json['appliedShare'],
    };
}
export function PromotionListResponseDTOToJSON(json) {
    return PromotionListResponseDTOToJSONTyped(json, false);
}
export function PromotionListResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(PromotionResponseDTOToJSON)),
        'appliedShare': value['appliedShare'],
    };
}
